import { render, staticRenderFns } from "./user_sign_statistic.vue?vue&type=template&id=bce85722&scoped=true"
import script from "./user_sign_statistic.vue?vue&type=script&lang=js"
export * from "./user_sign_statistic.vue?vue&type=script&lang=js"
import style0 from "./user_sign_statistic.vue?vue&type=style&index=0&id=bce85722&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bce85722",
  null
  
)

export default component.exports